/**
 * Visitor Tracking Utility
 * Manages first-party persistent visitor identity across sessions, page loads, and reloads.
 */
export function getOrCreateVisitorId(): string {
  try {
    let vid = localStorage.getItem('mcq_pulse_vid');
    if (!vid || typeof vid !== 'string' || vid.trim().length < 8) {
      // Check cookie fallback if localStorage was cleared
      const match = document.cookie.match(/(?:^|;\s*)mcq_pulse_vid=([^;]+)/);
      if (match && match[1]) {
        vid = decodeURIComponent(match[1]);
        localStorage.setItem('mcq_pulse_vid', vid);
      } else {
        // Generate a persistent visitor UUID
        const randomPart = Math.random().toString(36).substring(2, 12) + Math.random().toString(36).substring(2, 12);
        vid = `vid_${Date.now().toString(36)}_${randomPart}`;
        localStorage.setItem('mcq_pulse_vid', vid);
        try {
          document.cookie = `mcq_pulse_vid=${encodeURIComponent(vid)}; path=/; max-age=31536000; SameSite=Lax`;
        } catch (_) {}
      }
    }
    return vid;
  } catch (e) {
    return 'vid_anon_' + Date.now();
  }
}
